import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "amount-table font-size-h3-normal"
  }, [_vm.service.is_customer_service_money_item === 1 ? [Object.keys(_vm.service).length > 0 ? _c('div', {
    staticClass: "amount-table-one"
  }, [_vm._m(0), _c('div', {
    staticClass: "table-list"
  }, [_c('div', {
    staticClass: "service-item service-item-first",
    staticStyle: {
      "width": "8.2rem"
    }
  }, [_vm._v(" " + _vm._s("" + _vm.serviceName) + " ")]), _c('div', {
    staticClass: "service-item"
  }, [_vm._v(" " + _vm._s(_vm.service.service_type) + " ")]), _c('div', {}, [_vm._v(" " + _vm._s(_vm.service.offer_price) + i18n.tc("671") + _vm._s(_vm.service.unit) + "*" + _vm._s(_vm.service.service_num) + _vm._s(_vm.service.unit) + " ")])]), _vm._l(_vm.extServiceItems, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "table-list"
    }, [_c('div', {
      staticClass: "service-item service-item-first",
      staticStyle: {
        "width": "8.2rem"
      }
    }, [_vm._v(" " + _vm._s(item.service_name) + " ")]), _c('div', {
      staticClass: "service-item"
    }, [_vm._v(" " + _vm._s(item.service_type_name) + " ")]), _c('div', {}, [_vm._v(_vm._s(item.service_price) + i18n.tc("671") + _vm._s(item.unit) + " x " + _vm._s(item.service_num) + _vm._s(item.unit))])]);
  }), _c('div', {
    staticClass: "table-list"
  }, [_c('div', {
    staticClass: "service-item service-item-first"
  }), _c('div', {
    staticClass: "service-item"
  }), _c('div', {}, [_vm._v(" " + i18n.tc("672") + _vm._s((_vm.service.offer_price * _vm.service.service_num ? _vm.service.offer_price * _vm.service.service_num : 0 * 1) + _vm.otherServiceCost) + (i18n.tc("604") + " "))])])], 2) : _vm._e()] : _vm._e(), _vm.sparePartList.length > 0 ? _c('div', {
    staticClass: "amount-table-two"
  }, [_vm._m(1), _vm._l(_vm.sparePartList, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "table-list"
    }, [_c('div', {
      staticClass: "service-item service-item-first"
    }, [_vm._v(" " + _vm._s(item.sparepart_name) + " ")]), _c('div', {
      staticClass: "service-item"
    }, [_vm._v(" " + _vm._s(item.sparepart_type) + " ")]), _c('div', {}, [_vm._v(_vm._s(item.sale_price) + i18n.tc("671") + _vm._s(item.unit) + "*" + _vm._s(item.sparepart_num) + _vm._s(item.unit))])]);
  }), _c('div', {
    staticClass: "table-list"
  }, [_c('div', {
    staticClass: "service-item service-item-first"
  }), _c('div', {
    staticClass: "service-item"
  }), _c('div', {}, [_vm._v(i18n.tc("673") + _vm._s(_vm.service.sparepart_amount || '0'))])])], 2) : _vm._e(), _vm.moneyItemList.length > 0 || _vm.service.other_amount || _vm.service.preferential_amount ? _c('div', {
    staticClass: "amount-table-two"
  }, [_vm._m(2), _c('div', {
    staticClass: "table-list"
  }, [_c('div', {
    staticClass: "amount-item service-item-first"
  }, [_vm._v(i18n.tc("674"))]), _c('div', {}, [_vm._v(_vm._s(_vm.service.other_amount || '0') + i18n.tc("604"))])]), _vm._l(_vm.moneyItemList, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "table-list"
    }, [_c('div', {
      staticClass: "amount-item service-item-first"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {}, [_vm._v(_vm._s(item.type === 1 ? item.fix_amount : item.value || '0') + i18n.tc("604"))])]);
  }), _c('div', {
    staticClass: "table-list"
  }, [_c('div', {
    staticClass: "amount-item service-item-first"
  }, [_vm._v(i18n.tc("675"))]), _c('div', {}, [_vm._v("-" + _vm._s(_vm.service.preferential_amount || '0') + i18n.tc("604"))])])], 2) : _vm._e()], 2), _c('div', {
    staticClass: "remark"
  }, [_c('div', {
    staticClass: "remark-label"
  }, [_vm._v(i18n.tc("676"))]), _c('div', {
    staticClass: "remark-value"
  }, [_vm._v(" " + _vm._s(_vm.service.charge_remark || '-') + " ")])])]);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "table-header"
  }, [_c('div', {
    staticClass: "service-item service-item-first",
    staticStyle: {
      "width": "8.2rem"
    }
  }, [_vm._v(i18n.tc("69"))]), _c('div', {
    staticClass: "service-item"
  }, [_vm._v(i18n.tc("677"))]), _c('div', {}, [_vm._v(i18n.tc("678"))])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "table-header"
  }, [_c('div', {
    staticClass: "service-item service-item-first"
  }, [_vm._v(i18n.tc("679"))]), _c('div', {
    staticClass: "service-item"
  }, [_vm._v(i18n.tc("680"))]), _c('div', {}, [_vm._v(i18n.tc("683"))])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "table-header"
  }, [_c('div', {
    staticClass: "amount-item service-item-first"
  }, [_vm._v(i18n.tc("674"))]), _c('div', {}, [_vm._v(i18n.tc("682"))])]);
}];
export { render, staticRenderFns };